import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../images/logo.svg";
import "./Header.css";


const dropdownItems = [
  {
    title: "CQC Services",
    to: "/services",
    section: "cqc-services",
    children: [
      { title: "CQC Registration", path: "/registration" },
      { title: "Mock Inspections", path: "/Sub-Pages/CQC_Mock" },
      { title: "Management Support", path: "/Sub-Pages/CQC_Support" },
      { title: "Maximising Occupancy", path: "/Sub-Pages/CQC_Occupancy" },
      { title: "Staff Training", path: "/Sub-Pages/CQC_Training" },
    ],
  },

  {
    title: "Care Home Sales",
    to: "/services",
    section: "care-home-sales",
    children: [
      { title: "Care Homes for Sale", path: "/Sub-Pages/Care_Sale" },
      { title: "Looking to Sell a Care Home", path: "/Sub-Pages/Care_Sell" },
    ],
  },

  {
    title: "Accounting",
    to: "/services",
    section: "accounting",
    children: [
      { title: "End of Year Accounts", path: "/Sub-Pages/Acc_Endof" },
      { title: "Payroll", path: "/Sub-Pages/Acc_Payroll" },
      { title: "Capital Allowances", path: "/Sub-Pages/Acc_Capital" },
      { title: "Financial Analysis", path: "/Sub-Pages/Acc_Financial" },
    ],
  },

  {
    title: "Software",
    to: "/services",
    section: "software",
    children: [
      { title: "Total Care Rota", path: "/Sub-Pages/Soft_Rota" },
      { title: "Governance Software", path: "/Sub-Pages/Soft_Governance" },
      { title: "Care Audit Software", path: "/Sub-Pages/Soft_Audit" },
      { title: "Our ERP System", path: "/Sub-Pages/Soft_ERP" },
      { title: "Capital Allowances", path: "/Sub-Pages/Soft_Allowances" },
    ],
  },

  {
    title: "Operational Management",
    to: "/services",
    section: "operational-management",
    children: [
      { title: "New Business Set Up", path: "/Sub-Pages/Opera_Setup" },
      {
        title: "Full Operational Management",
        path: "/Sub-Pages/Opera_fullManag",
      },
    ],
  },
];




const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);


  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeMenu = () => {
    setMenuActive(false);
    setDropdownOpen(false);
  };

   const navigate = useNavigate();

 const scrollToSection = (sectionId) => {
  navigate("/services", {
    state: { section: sectionId },
  });
};
  

  return (
    <header className={`navbar ${isScrolled ? "black" : ""}`}>
      {/* Logo */}
      <div className="logo">
        <NavLink to="/" end onClick={closeMenu}>
          <img src={Logo} alt="logo" />
        </NavLink>
      </div>

      {/* Mobile Menu Icon */}
      <div className="menu">
        <h4 onClick={() => setMenuActive(!menuActive)}>☰</h4>
      </div>

      {/* Navigation */}
      <nav className={`nav-links ${menuActive ? "active" : ""}`}>
        <NavLink to="/" end onClick={closeMenu}>
          Home
        </NavLink>

        <NavLink to="/about" onClick={closeMenu}>
          About Us
        </NavLink>
        

        {/* <li className="dropdown">
          <span>Our Services ▾</span>
    
              <ul className="dropdown-menu">
                {dropdownItems.map((item) => (
                  <li key={item.title} className="dropdown-item">
                    <button
                      className="parent-link"
                      onClick={() => handleParentClick(item)}
                    >
                      {item.title}
                    </button>
    
                    <ul className="sub-dropdown">
                      {item.children.map((child) => (
                        <li key={child.title}>
                          <NavLink to={child.path}>{child.title}</NavLink>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
        </li> */}

        <li className="dropdown">
  <span>Our Services ▾</span>

  <ul className="dropdown-menu">
    {dropdownItems.map((item) => (
      <li key={item.title} className="dropdown-item">
        <button
          className="parent-link"
          onClick={() => scrollToSection(item.section)}
        >
          {item.title}
        </button>

        <ul className="sub-dropdown">
          {item.children.map((child) => (
            <li key={child.title}>
              <NavLink to={child.path}>{child.title}</NavLink>
            </li>
          ))}
        </ul>
      </li>
    ))}
  </ul>
</li>

      
          
        <NavLink to="/insights" onClick={closeMenu} className="next">
          Insights
        </NavLink>

        <NavLink to="/faqs" onClick={closeMenu}>
          FAQs
        </NavLink>
        <NavLink to="/Registration" onClick={closeMenu}>
          CQC Registration
        </NavLink>
      </nav>

      {/* CTA Button */}
      <div>
        <div className="nav-actions">
          <button className="Navbar-btn">
            <a link href="https://flipbook.so/flip/jUUmHzGAoWFTRgkf2a8U">
              <span>Product brochure</span>
            </a>
          </button>
          <a href="tel:+4416033203325" className="Navbar-btn">
            Speak to Our Team
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;